

import angular from 'angular';
import constants from 'app/constants';
import {
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
} from 'app/services';
import { alerts } from 'app/components/global';
import controller from './edit-inherent-risk-profile-dialog.controller';
import template from './edit-inherent-risk-profile-dialog.html';


class dialogService {
  getOptions($event, { assessmentId, inherentRiskProfile }) {
    return {
      controller,
      controllerAs: 'editInherentRiskProfileDialogVM',
      locals: {
        assessmentId,
        inherentRiskProfile,
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.ecat.editInherentRiskProfileDialog', [
  alerts,
  constants,
  ecatDataService,
  ecatSharedModelService,
  loaderService,
  ssDialogService,
])
  .service('editInherentRiskProfileDialog', dialogService)
  .name;
